export default __webpack_public_path__ + "static/media/NRLevel4RightSideMap.374dfc9e.jpg";